import { useRoutes } from "react-router-dom";
import routes from "routes";

import "semantic-ui-css/semantic.min.css";

function App(): JSX.Element {
  const content = useRoutes(routes);

  return <div className="App">{content}</div>;
}

export default App;
